// src/components/dashboard/base/LazyCard.js
import React, { Suspense } from 'react';

// Loading placeholder for lazy-loaded cards
const CardLoadingPlaceholder = ({ width, height }) => {
  return (
    <div 
      style={{ 
        width: '100%', 
        height: '100%',
        minHeight: height ? `${height * 50}px` : '200px'
      }}
      className="bg-white rounded-lg shadow-sm p-4 animate-pulse"
    >
      <div className="h-4 bg-blue-100 rounded w-3/4 mb-4"></div>
      <div className="space-y-3">
        <div className="h-3 bg-blue-100 rounded"></div>
        <div className="h-3 bg-blue-100 rounded w-5/6"></div>
        <div className="h-3 bg-blue-100 rounded w-4/6"></div>
      </div>
    </div>
  );
};

// Error boundary for card loading failures
class CardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Card loading error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600 text-sm">Failed to load card component</p>
        </div>
      );
    }

    return this.props.children;
  }
}

// Wrapper component for lazy-loaded cards
const LazyCard = ({ component: Component, fallback, ...props }) => {
  return (
    <CardErrorBoundary>
      <Suspense fallback={fallback || <CardLoadingPlaceholder {...props} />}>
        <Component {...props} />
      </Suspense>
    </CardErrorBoundary>
  );
};

export default LazyCard;